<script>
  import { onMount } from "svelte";
  import SimpleInput from "./SimpleInput.svelte";
  import DateInput from "./DateInput.svelte";
  import SelectInput from "./SelectInput.svelte";
  import CheckboxInput from "./CheckboxInput.svelte";
  import RadioInput from "./RadioInput.svelte";
  import UploadInput from "./UploadInput.svelte";
  export let step = 0;
  export let alerts = [];
  export let data = {
    extras: "true",
  };
  let uploads = {};
  let emptyFields = {};
  const fields = [
    {
      type: "text",
      name: "name",
      label: "For -og efternavn:",
    },
    {
      type: "date",
      name: "born",
      label: "Fødselsdato: (dd-mm-åååå)",
    },
    {
      type: "number",
      size: 3,
      name: "height",
      label: "Højde (cm):",
    },
    {
      type: "select",
      name: "gender",
      label: "Køn:",
      options: ["Dreng", "Pige", "Andet"],
    },
    {
      type: "text",
      name: "address",
      label: "Adresse:",
    },
    {
      type: "number",
      size: 5,
      name: "postal-code",
      label: "Postnummer:",
    },
    {
      type: "text",
      name: "city",
      label: "By:",
    },
  ];
  onMount(() => {
    window.__data = data;
    document.addEventListener("keyup", (e) => {
      if (e.which == 13) {
        e.preventDefault();
        const focusables = Array.from(
          document.querySelectorAll(
            "section:not([hidden]) input, section:not([hidden]) button, section:not([hidden]) select",
          ),
        );
        const next = focusables.findIndex((elem) => elem === e.target) + 1;
        if (next === focusables.length) {
          return;
        }
        focusables[next].focus();
      }
    });
  });
  function getAllFieldNames(fields) {
    const fieldNames = [...fields.map((f) => f.name)];
    fieldNames.push("parentName");
    fieldNames.push("parentEmail");
    fieldNames.push("parentPhone");
    fieldNames.push("signature");
    return fieldNames;
  }
  function checkFilled(fields) {
    const fieldNames = getAllFieldNames(fields);
    return fieldNames.every((fieldName) => !!data[fieldName]);
  }
  function handleEmptyFields(fields) {
    const alertId = `${Math.round(Math.random() * 100000)}`;
    const fieldNames = getAllFieldNames(fields);
    emptyFields = fieldNames
      .map((fieldName) => !data[fieldName] && fieldName)
      .filter(Boolean)
      .reduce(
        (empty, field) => ({
          ...empty,
          [field]: () => {
            delete emptyFields[field];
            alerts = alerts.filter((item) => item.id !== alertId);
            emptyFields = emptyFields;
          },
        }),
        {},
      );
    alerts = [
      ...alerts,
      {
        title: "Tomme felter",
        body: "Du skal udfylde alle felter, før du kan fortsætte",
        id: alertId,
      },
    ];
  }

  function handleinProgressUploads() {
    const hasUploads = Object.values(uploads).filter(Boolean).length > 0;
    if (hasUploads) {
      alerts = [
        ...alerts,
        {
          title: "Uploading",
          body: "Uploading er i gang. Du må ikke indsende for din oploading er klar",
          id: `${Math.round(Math.random() * 100000)}`,
        },
      ];
    }
  }
  function mapLocaleGenderToEnglish(gender) {
    switch (gender) {
      case "Dreng":
        return "Male";
      case "Pige":
        return "Female";
      case "Andet":
        return "Other";
      default:
        return "Unknown";
    }
  }
  async function submit() {
    data.status = "submitted";
    data.gender = mapLocaleGenderToEnglish(data.gender);
    fetch(`/api/${data.id}`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  function closeAlert(id) {
    alerts = alerts.filter((item) => item.id !== id);
  }
</script>

{#if alerts.length > 0}
  <div class="alert-zone">
    {#each alerts as alert}
      <div class="alert">
        <div>
          <h3>{alert.title}</h3>
          <p>{alert.body}</p>
        </div>
        <button
          class="secondary"
          on:click={() => {
            closeAlert(alert.id);
          }}
        >
          <img src="/x-circle.svg" alt="stäng" />
        </button>
      </div>
    {/each}
  </div>
{/if}
<section hidden={step !== 2}>
  <h3>Om dig</h3>
  {#each fields as field}
    {#if field.type == "select"}
      <SelectInput
        name={field.name}
        bind:value={data[field.name]}
        options={field.options}
        empty={emptyFields[field.name]}
        label={field.label}
      />
    {:else if field.type == "date"}
      <DateInput
        name={field.name}
        bind:value={data[field.name]}
        options={field.options}
        empty={emptyFields[field.name]}
        type={field.type}
        label={field.label}
      ></DateInput>
    {:else}
      <SimpleInput
        name={field.name}
        bind:value={data[field.name]}
        options={field.options}
        empty={emptyFields[field.name]}
        size={field.size}
        type={field.type}
        label={field.label}
      />
    {/if}
  {/each}
  <SimpleInput
    name="some"
    bind:value={data.someAccounts}
    empty={emptyFields.someAccounts}
    type="text"
    label="SoMe (Instagram / TikTok (valgfrit):"
  />
  <div class="input-group">
    <SimpleInput
      name="parentname"
      bind:value={data.parentName}
      empty={emptyFields.parentName}
      type="text"
      label="Forælder/værges navn:"
    />
    <SimpleInput
      name="parentemail"
      bind:value={data.parentEmail}
      empty={emptyFields.parentEmail}
      type="text"
      label="E-mail på forældre/værge:"
    />
    <SimpleInput
      name="tel"
      bind:value={data.parentPhone}
      empty={emptyFields.parentPhone}
      type="text"
      label="Telefonnummer til forældre/værge:"
    />
  </div>
  <div class="input-group">
    <h3>Underskrift</h3>
    <UploadInput
      name="image"
      accept="image/*"
      bind:status={uploads.signature}
      bind:mediaId={data.signature}
      empty={emptyFields.signature}
      id={data.id}
      fileLabel="Signature"
      label="Upload et billede af forælder/værges underskrift her"
    />
  </div>
  <div class="nav-buttons">
    <button
      class="secondary plausible-event-name=go-back"
      on:click={() => {
        step--;
        window.scrollTo(0, 0);
      }}>Tilbage</button
    >
    <button
      class="plausible-event-name=step3"
      on:click={() => {
        const isFilled = checkFilled(fields);
        const noUploads =
          Object.values(uploads).filter((val) => val === null).length === 1;
        if (isFilled && noUploads) {
          step++;
          uploads = {};
        } else {
          handleEmptyFields(fields);
          handleinProgressUploads();
        }
        window.scrollTo(0, 0);
      }}>Næste</button
    >
    <div />
  </div>
</section>
<section hidden={step !== 3}>
  <h3>Billede:</h3>
  <p>
    Tag et billede af dig selv i god belysning, hvor hele dit ansigt er synligt.
  </p>
  <UploadInput
    name="image"
    accept="image/*"
    bind:status={uploads.image}
    bind:mediaId={data.applicantImage}
    empty={emptyFields.imageName}
    id={data.id}
    fileLabel="Profile picture"
    label="Upload dit billede"
  />
  <h3>Video 1 - sådan optager du din præsentationsvideo</h3>
  <p>
    I præsentationsfilmen skal du fortælle om dig selv, dine hobbyer, og hvorfor
    du vil være med i KLASSEN. Fortæl også gerne om din erfaring med at spille
    skuespil. Husk at filme et sted, hvor det er stille, og hvor lyset er godt.
    Videoen må max vare 2 minutter.
  </p>
  <UploadInput
    name="video_pres"
    accept="video/*"
    bind:status={uploads.videoPres}
    bind:mediaId={data.videoPresentation}
    empty={emptyFields.videoPres}
    id={data.id}
    fileLabel="Presentation"
    label="Upload præsentationsvideo her"
  />
  <h3>Video 2 - Sådan optager du din skuespilsvideo</h3>
  <p>
    Din bedste ven ringer til dig. Du er i godt humør og tror, vennen ringer,
    fordi I skal hænge ud i aften. Men i virkeligheden vil vennen fortælle, at
    han/hun i stedet har lavet en aftale med din anden bedste ven, som du har
    introduceret ham/hende for. Hvad gør du? Husk at filme et sted, hvor det er
    stille, og hvor lyset er godt. Videoen må max vare 2 minutter.
  </p>
  <UploadInput
    name="video_impro"
    accept="video/*"
    bind:status={uploads.videoSelfTape}
    bind:mediaId={data.selfTape}
    empty={emptyFields.videoSelfTape}
    id={data.id}
    fileLabel="Self-tape"
    label="Upload skuespilsvideo her"
  />
  <RadioInput
    name="extras"
    title="Kan du også forestille dig at være statist i KLASSEN?"
    bind:value={data.extras}
    empty={emptyFields.extras}
    alternatives={[
      { label: "Ja", value: "true" },
      { label: "Nej", value: "false" },
    ]}
  />
  <div>
    <CheckboxInput
      bind:value={data.gdpr}
      name="gdpr"
      empty={emptyFields.gdpr}
      label="Mine forældre og jeg er indforstået med, at BBC Studios midlertidigt kan gemme mine personlige data i forbindelse med ansøgning om at komme til med til KLASSEN sæson 17 & 18. Efter castingen slettes alle personlige oplysninger. Du har ret til at kontakte os hvis du ønsker at få oplysninger om de data vi har om dig. For at anmode om rettelse, overførsel eller anmode om sletning af dine data gør du nemmest ved at kontakte os på: klassen@bbcstudiosnordic.com.
"
    />
  </div>
  <div class="nav-buttons">
    <button
      class="secondary plausible-event-name=go-back"
      on:click={() => {
        step--;
        window.scrollTo(0, 0);
      }}>Tilbage</button
    >
    <button
      class="plausible-event-name=submit"
      on:click={(e) => {
        const fields = ["extras", "gdpr"].map((name) => ({ name }));
        e.preventDefault();
        e.stopPropagation();
        const isFilled = checkFilled(fields);
        const noUploads =
          Object.values(uploads).filter((val) => val === null).length === 3;
        if (isFilled && noUploads) {
          submit();
          step++;
        } else {
          handleEmptyFields(fields);
          handleinProgressUploads();
        }
        window.scrollTo(0, 0);
        return false;
      }}>Indsend</button
    >
    <div />
  </div>
</section>
<section hidden={step !== 4}>
  <div class="input-group">
    <h2>TAK!</h2>
    <h3>NU ER DIN ANSØGNING KLAR!</h3>
  </div>

  <h3>Bekræftelsesmail</h3>
  <p>
    Når du har sendt din ansøgning, vil du få en mail om, at vi har modtaget din
    ansøgning.
  </p>

  <h3>Hvad sker der nu?</h3>
  <p>
    Vi vil se ALLE ansøgninger igennem og vil kontakte dem, der er gået videre i
    castingen senest 28. februar 2025. Hvis du ikke har hørt fra os inden da, er
    du desværre ikke kommet videre.
  </p>

  <p>Vi glæder os til at modtage din ansøgning.</p>
  <p>De bedste hilsner, KLASSEN-teamet</p>
</section>

<style>
  .alert-zone {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 6px;
    z-index: 1;
  }
  .alert h3 {
    color: white;
  }
  .alert {
    background-color: var(--alert-color);
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    box-shadow:
      0 19px 38px rgba(0, 0, 0, 0.3),
      0 15px 12px rgba(0, 0, 0, 0.22);
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
  .alert > div {
    padding: 1em 2em;
  }
  button {
    cursor: pointer;
  }
  .alert button.secondary {
    border: 0;
    text-decoration: underline;
    background: transparent;
    outline: none;
    font-size: small;
  }
  section > * {
    margin-top: 25px;
  }
  .input-group {
    padding: 16px 0;
  }
</style>
